

import type { ICartApi, ShopifyCartAddInput, ShopifyCartAddOutput, ShopifyCartChangeInput, ShopifyCartData, ShopifyCartItemData, ShopifyCartUpdateInput } from "./types/ICartApi";

export class CartApi implements ICartApi {
  private post<Output>(url: string, data?: object): Promise<Output> {

    const request = new Request(url, {
      method: "POST",
      headers: {
        ...(data ? { "Content-Type": "application/json" } : {}),
        "X-Theme": "true",
      },
      body: data ? JSON.stringify(data) : undefined,
    });

    return window.fetch(request).then(res => res.json() as Promise<Output>);
  }

  private get<Output>(url: string): Promise<Output> {
    const request = new Request(url, {
      headers: {
        "X-Theme": "true",
      }
    });
    
    return window.fetch(request).then(res => res.json() as Promise<Output>);
  }

  async cartAdd({ items }: ShopifyCartAddInput): Promise<ShopifyCartAddOutput> {
    return this.post<{
      items: ShopifyCartItemData[];
    }>("/cart/add.js", { items });
  }
  async cartUpdate(data: ShopifyCartUpdateInput): Promise<ShopifyCartData> {
    return this.post<ShopifyCartData>("/cart/update.js", data);
  }
  async cartChange(data: ShopifyCartChangeInput): Promise<ShopifyCartData> {
    return this.post<ShopifyCartData>("/cart/change.js", data);
  }

  async cartGet(): Promise<ShopifyCartData> {
    return this.get<ShopifyCartData>("/cart.js");
  }

  async cartClear(): Promise<ShopifyCartData> {
    return this.post<ShopifyCartData>("/cart/clear.js");
  }

}